export default __webpack_public_path__ + "fonts/Jost-500-Medium.ttf";